import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from "@angular/router";
import { Injectable } from "@angular/core";
import { AuthRoute } from "./auth.route";
import { tokenNotExpired } from "./helper";
import { ConfigService } from "../../services/config.service";
import { TokenService } from "./token.service";

@Injectable({
  providedIn: "root"
})
export class AuthGuard implements CanActivate {
  private _authRoute: AuthRoute;

  constructor(
    private _router: Router,
    private _configService: ConfigService,
    private _tokenService: TokenService
  ) {
    this._authRoute = this._configService.getAuthRoute();
  }

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.checkDisabled()) {
      return true;
    }

    try {
      if (tokenNotExpired()) {
        return true;
      }

      return this.logout(state.url);
    } catch (error) {
      return this.logout(state.url);
    }
  }

  logout(url?: string): boolean {
    this._tokenService.removeToken();

    if (url) {
      this._router.navigate([this._authRoute.LoginUrl], {
        queryParams: {
          returnUrl: url
        }
      });
    } else {
      this._router.navigate([this._authRoute.LoginUrl]);
    }

    return false;
  }

  checkDisabled() {
    return this._configService.disableGuard();
  }
}
